import { render, staticRenderFns } from "./page-header-compact.vue?vue&type=template&id=25fc0982&scoped=true"
import script from "./page-header-compact.vue?vue&type=script&lang=js"
export * from "./page-header-compact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc0982",
  null
  
)

export default component.exports